import React from "react";
import { Link } from "react-router-dom";
import { Plane, Gamepad2, Flame, Target, MessageCircle } from "lucide-react";

const BottomNavigation = () => {
  // Navigation items with Lucide icons
  const navItems = [
    {
      name: "AVIATOR",
      icon: <Plane size={20} />,
      path: "/game/avaitor?provider=aviator&mode=real",
    },
    { name: "GAMES", icon: <Gamepad2 size={20} />, path: "/casino" },
    { name: "PROMO", icon: <Flame size={20} />, path: "/" },
    {
      name: "VIRTUALS",
      icon: <Target size={20} />,
      path: "/game/gfhjdghvfdvsaddd?provider=eurovirtual&mode=real",
    },
    { name: "CHAT", icon: <MessageCircle size={20} />, path: "/" },
  ];

  return (
    <div className="s15:hidden flex justify-between items-center fixed bottom-0 z-[9] w-full bg-charcoal p-2">
      {navItems.map((item, index) => (
        <Link
          key={index}
          to={item.path}
          className="flex flex-col items-center px-2 py-1"
        >
          <span className="text-green-400">{item.icon}</span>
          <span className="text-white text-xs">{item.name}</span>
        </Link>
      ))}
    </div>
  );
};

export default BottomNavigation;
